<template>
  <div class="admin-layout d-flex" style="min-height: 100vh; background: var(--bg-main);">
    <!-- 左侧导航 -->
    <aside class="admin-sidebar">
      <div class="sidebar-brand px-3 py-4 text-white font-weight-bold" style="font-size: 1.1rem; border-bottom: 1px solid #2d3d51;">
        后台管理
      </div>
      <nav class="mt-2">
        <router-link
          v-for="item in menuItems"
          :key="item.path"
          :to="item.path"
          class="sidebar-item d-flex align-items-center px-3 py-2 text-white-50"
          active-class="sidebar-item-active"
          style="text-decoration: none; font-size: 0.9rem; transition: background 0.2s;"
        >
          <span class="mr-2">{{ item.icon }}</span>
          <span>{{ item.label }}</span>
        </router-link>
      </nav>
    </aside>

    <!-- 右侧内容 -->
    <main class="flex-grow-1 p-4 admin-content">
      <router-view />
    </main>
  </div>
</template>

<script>
export default {
  name: 'AdminLayout',
  data: function() {
    return {
      menuItems: [
        { path: '/admin/api-auth', icon: '[KEY]', label: 'API 权限管理' },
        { path: '/admin/subscription', icon: '[￥]', label: '订阅定价管理' },
        { path: '/admin/referral', icon: '[USR]', label: '邀请记录管理' }
      ]
    }
  },
  created: function() {
    if (!this.isAdmin()) {
      this.$router.replace('/home')
    }
  },
  methods: {
    isAdmin: function() {
      try {
        // 方案1: 从 user_info 读取 (Flask 邮箱/微信登录存储的 key)
        // roles 是逗号分隔字符串, 如 "ADMIN" 或 "ADMIN,USER"
        var raw = localStorage.getItem('user_info')
        if (raw) {
          var info = JSON.parse(raw)
          var roles1 = (info.roles || '').toLowerCase()
          if (roles1.indexOf('admin') !== -1) return true
        }
        // 方案2: 从 JWT Token payload 中解码角色 (FastAPI 登录颁发的 token)
        var token = localStorage.getItem('token')
        if (token) {
          var parts = token.split('.')
          if (parts.length === 3) {
            var payload = JSON.parse(atob(parts[1]))
            var roles2 = (payload.roles || '').toLowerCase()
            if (roles2.indexOf('admin') !== -1) return true
          }
        }
        return false
      } catch (e) {
        return false
      }
    }
  }
}
</script>

<style scoped>
.admin-sidebar {
  width: 200px;
  min-height: 100vh;
  background: #0f172a;
  flex-shrink: 0;
  border-right: 1px solid var(--border-color);
}

.sidebar-item:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #fff !important;
}
.sidebar-item-active {
  background: #2563eb !important;
  color: #fff !important;
}

/* 手机端及平板适配，对齐移动端导航栏断点 991px */
@media (max-width: 991px) {
  .admin-layout {
    flex-direction: column !important;
  }
  
  .admin-sidebar {
    width: 100% !important;
    min-height: auto !important;
    border-right: none !important;
    border-bottom: 1px solid var(--border-color);
  }
  
  .sidebar-brand {
    padding: 12px 16px !important;
    border-bottom: none !important;
    text-align: center;
  }
  
  nav {
    display: flex !important;
    flex-direction: row !important;
    margin-top: 0 !important;
    border-top: 1px solid #2d3d51;
    overflow-x: auto;
  }
  
  .sidebar-item {
    flex: 1;
    justify-content: center;
    padding: 12px 8px !important;
    white-space: nowrap;
    text-align: center;
    font-size: 0.85rem !important;
  }
  
  .admin-content {
    padding: 12px !important;
    width: 100% !important;
    overflow-x: hidden;
  }
}
</style>
